export default {"src":"/_next/static/media/search-icon-black.6ec2e3c4.svg","height":20,"width":21,"blurWidth":0,"blurHeight":0};